import React from "react";
import { CheckCircle2, Clock3, OctagonAlert, MinusCircle } from "lucide-react";

const PILL_CONFIG = {
  unreported: {
    label: "Not reported",
    Icon: MinusCircle,
    style: {
      background: "var(--health-between-bg)",
      color: "var(--health-between-fg)",
      borderColor: "var(--health-between-border)",
    },
  },
  on_track: {
    label: "On track",
    Icon: CheckCircle2,
    style: {
      background: "var(--health-on-track-bg)",
      color: "var(--health-on-track-fg)",
      borderColor: "var(--health-on-track-border)",
    },
  },
  waiting: {
    label: "Waiting on something",
    Icon: Clock3,
    style: {
      background: "var(--health-waiting-bg)",
      color: "var(--health-waiting-fg)",
      borderColor: "var(--health-waiting-border)",
    },
  },
  blocked: {
    label: "Blocked",
    Icon: OctagonAlert,
    style: {
      background: "var(--health-blocked-bg)",
      color: "var(--health-blocked-fg)",
      borderColor: "var(--health-blocked-border)",
    },
  },
  between_cycles: {
    label: "Between phases",
    Icon: MinusCircle,
    style: {
      background: "var(--health-between-bg)",
      color: "var(--health-between-fg)",
      borderColor: "var(--health-between-border)",
    },
  },
};

export const HealthPill = ({ health = "between_cycles", size = "sm", showLabel = true, testId = "health-pill" }) => {
  const config = PILL_CONFIG[health] || PILL_CONFIG.between_cycles;
  const { Icon, label, style } = config;
  const paddingClass = size === "lg" ? "px-3 py-1.5 text-sm" : "px-2.5 py-1 text-xs";
  const iconSize = size === "lg" ? 14 : 12;

  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full border font-medium ${paddingClass}`}
      style={style}
      role="status"
      aria-label={`Status: ${label}`}
      data-testid={testId}
    >
      <Icon size={iconSize} strokeWidth={2.25} aria-hidden />
      {showLabel && <span>{label}</span>}
    </span>
  );
};

export default HealthPill;
